// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 628 ? "device-detector" : chunkId) + "." + {"484":"e8939760e51b25892e84","628":"f1a1bfcc1ca2d932a09d"}[chunkId] + ".chunk.js";
};